import React,{useEffect} from 'react'
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import Hero from './Components/Hero'
import WhatWeBelive from "./Components/WhatWeBelive";
import WhyChooseUs from "./Components/WhyChooseUs";
import WhatCanWeDo from "./Components/WhatCanWeDo";
import CaseStudies from "./Components/CaseStudies";
import Clients from "./Components/Clients";
import ClientSpeak from "./Components/ClientSpeak";
import Contect from "./Components/Contect";
import "./Home.scss";
import ReactGA from "react-ga";
import AspiringIndustries from './Components/AspiringIndustries';
import IndustriesWorkedFor from './Components/IndustriesWorkedFor';
import OurBlogs from './Components/OurBlogs';
import OurVideo from './Components/OurVideo';
import GetQuote from '../../Components/GetQuote/GetQuote';
import { usePageTitle } from '../../utils/usePageTitle';

export default function Home() {
  usePageTitle(''); // Uses default title from config
  
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);
  return (
    <>
      <Navigation offer={true} />
      {/* <GetQuote /> */}
      <Hero />
      <IndustriesWorkedFor/>
      <WhatCanWeDo />
      {/* <AspiringIndustries /> */}
      <CaseStudies  />
      <WhatWeBelive />
      <WhyChooseUs />
      <ClientSpeak />
      <OurBlogs />
      <OurVideo/>
      <Clients />
      <Contect /> 
      <Footer />
    </>
  );
}
